"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_KEY = exports.PromoAppliesTo = exports.PromoRequiresProducts = exports.appTypes = exports.promoErrors = exports.promoTypes = void 0;
exports.promoTypes = {
    FIXED: "fixed",
    PERCENTAGE: "percentage",
};
exports.promoErrors = {
    MIN_BASKET: "minBasket",
    LAST_TIME_USAGE: "lastTimeUsage",
    MISSING_REQUIRED_PRODUCTS: 'missingRequiredProducts',
};
exports.appTypes = {
    KIOSK: "kiosk",
    POS: "pos",
    ONLINE: "online",
    DELIVERY: "delivery",
    OPAT: "opat",
};
var PromoRequiresProducts;
(function (PromoRequiresProducts) {
    PromoRequiresProducts["ALL"] = "all";
    PromoRequiresProducts["SOME"] = "some";
})(PromoRequiresProducts = exports.PromoRequiresProducts || (exports.PromoRequiresProducts = {}));
exports.PromoAppliesTo = {
    AssocBundles: "assoc_bundles",
    AssocMostExpensive: "assoc_most_expensive",
    Order: "order",
};
exports.SORT_KEY = "discountsSortOrder";
